import { Component } from "react";

// markup
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import CurrencyFormater from "../../../shared/ui/Currency.Input";

export default class TableCellOfferActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      riskOpen: false,
      nominalOpen: false,
      risk: {
        LoanAmount: "",
        LoanTerm: "",
        RiskOfDefaultYearOne: "",
        IntermediationFeeRate: "",
        InvoiceFee: "",
      },
      nominal: {
        LoanAmount: "",
        LoanTerm: "",
        NominalInterest: "",
        IntermediationFeeRate: "",
        InvoiceFee: "",
      },
    };
  }

  handleRiskFieldChange = (event) => {
    var name = event.target.name;
    this.setState({
      ...this.state,
      risk: {
        ...this.state.risk,
        [name]: event.target.value,
      },
    });
  };

  handleNominalFieldChange = (event) => {
    var name = event.target.name;
    this.setState({
      ...this.state,
      nominal: {
        ...this.state.nominal,
        [name]: event.target.value,
      },
    });
  };

  handleRiskOpen = () => {
    this.setState({
      ...this.state,
      riskOpen: true,
    });
  };

  handleRiskClose = () => {
    this.setState({
      ...this.state,
      riskOpen: false,
    });
  };

  handleRiskSend = () => {
    let riskBasedOffer = Object.assign({}, this.state.risk, {});
    if (
      !riskBasedOffer.IntermediationFeeRate &&
      riskBasedOffer.IntermediationFeeRate != 0
    )
      delete riskBasedOffer.IntermediationFeeRate;

    this.props.setRiskBasedOffer(
      this.props.item.Id,
      this.props.item.AccountId,
      riskBasedOffer,
    );
    this.handleRiskClose();
  };

  handleNominalOpen = () => {
    this.setState({
      ...this.state,
      nominalOpen: true,
    });
  };

  handleNominalClose = () => {
    this.setState({
      ...this.state,
      nominalOpen: false,
    });
  };

  handleNominalSend = () => {
    let nominalBasedOffer = Object.assign({}, this.state.nominal, {});
    if (
      !nominalBasedOffer.IntermediationFeeRate &&
      nominalBasedOffer.IntermediationFeeRate != 0
    )
      delete nominalBasedOffer.IntermediationFeeRate;

    this.props.setNominalBasedOffer(
      this.props.item.Id,
      this.props.item.AccountId,
      nominalBasedOffer,
    );
    this.handleNominalClose();
  };

  render() {
    const riskActions = [
      <Button
        key="confirm"
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleRiskSend}
      >
        Confirm
      </Button>,
      <Button
        key="cancel"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleRiskClose}
      >
        Cancel
      </Button>,
    ];

    const nominalActions = [
      <Button
        key="confirm"
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        onClick={this.handleNominalSend}
      >
        Confirm
      </Button>,
      <Button
        key="cancel"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleNominalClose}
      >
        Cancel
      </Button>,
    ];

    return (
      <div className="table-cell-actions">
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleRiskOpen}
        >
          Risk
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleNominalOpen}
        >
          Nominal
        </Button>
        <Dialog
          title="Manual risk based offer"
          modal={false}
          open={this.state.riskOpen}
          onClose={this.handleRiskClose}
        >
          <DialogContent>
            <CurrencyFormater
              label="Loan amount"
              type="text"
              name="LoanAmount"
              value={this.state.risk.LoanAmount}
              onChange={this.handleRiskFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Loan term"
              type="number"
              name="LoanTerm"
              value={this.state.risk.LoanTerm}
              onChange={this.handleRiskFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Admin fee"
              type="number"
              name="InvoiceFee"
              value={this.state.risk.InvoiceFee}
              onChange={this.handleRiskFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Intermediation fee rate"
              type="number"
              name="IntermediationFeeRate"
              value={this.state.risk.IntermediationFeeRate}
              onChange={this.handleRiskFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Risk of default year one"
              type="number"
              name="RiskOfDefaultYearOne"
              value={this.state.risk.RiskOfDefaultYearOne}
              onChange={this.handleRiskFieldChange}
            />
          </DialogContent>
          <DialogActions>{riskActions}</DialogActions>
        </Dialog>
        <Dialog
          title="Manual nominal based offer"
          modal={false}
          open={this.state.nominalOpen}
          onClose={this.handleNominalClose}
        >
          <DialogContent>
            <CurrencyFormater
              label="Loan amount"
              type="text"
              name="LoanAmount"
              value={this.state.nominal.LoanAmount}
              onChange={this.handleNominalFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Loan term"
              type="number"
              name="LoanTerm"
              value={this.state.nominal.LoanTerm}
              onChange={this.handleNominalFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Admin fee"
              type="number"
              name="InvoiceFee"
              value={this.state.nominal.InvoiceFee}
              onChange={this.handleNominalFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Intermediation fee rate"
              type="number"
              name="IntermediationFeeRate"
              value={this.state.nominal.IntermediationFeeRate}
              onChange={this.handleNominalFieldChange}
            />
            <TextField
              size="small"
              variant="outlined"
              label="Nominal interest"
              type="number"
              name="NominalInterest"
              value={this.state.nominal.NominalInterest}
              onChange={this.handleNominalFieldChange}
            />
          </DialogContent>
          <DialogActions>{nominalActions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}
